module.exports = __webpack_public_path__ + "static/media/product_journey.e190283d.png";